__webpack_require__.p = "/issues/39/john-broughams-columbus-burlesque/";